import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { useMembershipPeriod } from '@techstyle/react-accounts';

import {
  isBilledEmpVip as getIsBilledEmpVip,
  isUnlockedXclusiveProductVisible as getIsUnlockedXclusiveVisible,
} from './selectors';

function useUnlockedXclusive() {
  // When a product is tagged as "Unlocked Xclusive", it should ONLY display for a) EMP VIPs
  // who have been billed already for the month, and b) all non-EMP users (lead, VIP, visitors).
  // Billed EMP VIPs are the only ones to see the "Unlocked Xclusive" product tag. Because of
  // these requirements, we need to get `membershipPeriod` for all users to see if they're billed
  // or not.
  useMembershipPeriod();

  const isBilledEmpVip = useSelector(getIsBilledEmpVip);
  const isUnlockedXclusiveProductVisible = useSelector(
    getIsUnlockedXclusiveVisible
  );
  const shouldSeeUnlockedXclusiveBadge = isBilledEmpVip;

  return useMemo(
    () => ({
      isUnlockedXclusiveProductVisible,
      shouldSeeUnlockedXclusiveBadge,
    }),
    [isUnlockedXclusiveProductVisible, shouldSeeUnlockedXclusiveBadge]
  );
}

export default useUnlockedXclusive;
